import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'underscore';

import * as navigation from 'Navigation';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import ProteinComplexProperties from './AaSequenceComplexProperties';

class ProteinComplexPropertiesTabState extends navigation.TabState {
  constructor({proteinIds}: {proteinIds: Array<string>}) {
    super();
    this.set('proteinIds', proteinIds);
  }

  override defaults(): navigation.TabStateDefaults {
    // eslint-disable-next-line no-restricted-syntax
    return _.extend(super.defaults(), {
      title: 'AA Sequence Properties',
      closeable: true,
    });
  }
}

class ProteinComplexPropertiesTabView extends Backbone.View<ProteinComplexPropertiesTabState> {
  constructor({model}: {model: ProteinComplexPropertiesTabState}) {
    super();
    this.model = model;
  }

  override render(): this {
    renderToDOM(<ProteinComplexProperties proteinIds={this.model.get('proteinIds')} />, this.el);
    return this;
  }

  override remove(): this {
    ReactDOM.unmountComponentAtNode(this.el);
    super.remove();
    return this;
  }
}

ProteinComplexPropertiesTabView.prototype.className = 'buffer-tab buffer-tab-reset buffer-tab--no-padding';

export {ProteinComplexPropertiesTabState as tabState, ProteinComplexPropertiesTabView as tabView};
